import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import SpacingBody from './SpacingBody';

const View = (props) => <SpacingBody {...props} />;

export default withBlockExtensions(View);
